import { render, staticRenderFns } from "./FilterCardPaginationSideCard.vue?vue&type=template&id=319727f9&scoped=true"
import script from "./FilterCardPaginationSideCard.vue?vue&type=script&lang=ts"
export * from "./FilterCardPaginationSideCard.vue?vue&type=script&lang=ts"
import style0 from "./FilterCardPaginationSideCard.vue?vue&type=style&index=0&id=319727f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319727f9",
  null
  
)

export default component.exports